import { Controller } from "@hotwired/stimulus"
import Mark from "mark.js"

export default class extends Controller {
  static targets = ["input", "results"]

  connect() {
    this.mark()
  }

  mark(event) {
    if (event && event.target.id !== "news_list") return
    if (!this.hasResultsTarget) return

    const query = this.inputTarget.value.trim()
    const marker = new Mark(this.resultsTarget)
    marker.unmark({ done: () => { if (query) marker.mark(query) } })
  }
}
